var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomersEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 48,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.7415 42.2535H5.94156L9.69248 19.9507H88.0119L91.7415 42.2535Z",
    fill: "#BC4F39"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.23291 22.683L9.69254 19.9507L9.23291 22.683Z",
    fill: "#B67E6C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.4687 22.683H9.23291L9.69254 19.9507H88.012L88.4687 22.683Z",
    fill: "#9F3A32"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7946 38.6475H11.992L15.2152 19.9507H15.9479L12.7946 38.6475Z",
    fill: "#84342B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0845 38.6475H19.2813L21.8699 19.9507H22.602L20.0845 38.6475Z",
    fill: "#84342B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3738 38.6475H26.5711L28.5234 19.9507H29.2561L27.3738 38.6475Z",
    fill: "#84342B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6637 38.6475H33.8611L35.1771 19.9507H35.9104L34.6637 38.6475Z",
    fill: "#84342B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.953 38.6475H41.1504L41.8312 19.9507H42.5639L41.953 38.6475Z",
    fill: "#84342B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2429 38.6475H48.4397L48.4859 19.9507H49.2181L49.2429 38.6475Z",
    fill: "#84342B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.5328 38.6475H55.7296L55.1401 19.9507H55.8722L56.5328 38.6475Z",
    fill: "#84342B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.8222 38.6475H63.0196L61.7938 19.9507H62.5265L63.8222 38.6475Z",
    fill: "#84342B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.1121 38.6475H70.3095L68.4485 19.9507H69.1806L71.1121 38.6475Z",
    fill: "#84342B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.4016 38.6475H77.5984L75.1022 19.9507H75.8361L78.4016 38.6475Z",
    fill: "#84342B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.6908 38.6475H84.8881L81.7562 19.9507H82.4896L85.6908 38.6475Z",
    fill: "#84342B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.8886 20.4965V18.4928C88.8886 18.3427 88.7679 18.2197 88.6195 18.2197H9.30866C9.15968 18.2197 9.039 18.3427 9.039 18.4928V20.4965H88.8886Z",
    fill: "#BC4F39"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.8886 19.0397V18.4928C88.8886 18.3427 88.7679 18.2197 88.6195 18.2197H9.30866C9.15968 18.2197 9.039 18.3427 9.039 18.4928V19.0397H88.8886Z",
    fill: "#E06E54"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.41681 87.754H91.4372V43.6235H6.41681V87.754Z",
    fill: "#D79E5C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1899 81.9987H13.4384V80.6014H55.1898V52.022H56.1899V81.9987Z",
    fill: "#B56443"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.41681 49.6951H91.4372V43.6235H6.41681V49.6951Z",
    fill: "#B68148"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.0193 84.1704H83.8944V51.4365H84.7692C84.9072 51.4365 85.0193 51.548 85.0193 51.6871V84.1704Z",
    fill: "#B56443"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.0206 92.2537C93.0206 92.3923 92.9086 92.5043 92.7706 92.5043H4.91622C4.77822 92.5043 4.66678 92.3923 4.66678 92.2537V84.4193C4.66678 84.2819 4.77822 84.1704 4.91622 84.1704H92.7706C92.9086 84.1704 93.0206 84.2819 93.0206 84.4193V92.2537Z",
    fill: "#EAD0BA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.7706 92.5046H4.91622C4.77822 92.5046 4.66678 92.3926 4.66678 92.254V91.2539H93.0206V92.254C93.0206 92.3926 92.9086 92.5046 92.7706 92.5046Z",
    fill: "#CFB297"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.0206 85.8784V84.4193C93.0206 84.2819 92.9086 84.1704 92.7706 84.1704H4.91622C4.77822 84.1704 4.66678 84.2819 4.66678 84.4193V85.8784H93.0206Z",
    fill: "#DED7C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.8945 89.6286C83.8945 89.7672 83.7824 89.8786 83.6444 89.8786H61.5166C61.3786 89.8786 61.2665 89.7672 61.2665 89.6286V50.8734C61.2665 50.736 61.3786 50.6245 61.5166 50.6245H83.6444C83.7824 50.6245 83.8945 50.736 83.8945 50.8734V89.6286Z",
    fill: "#EAD0BA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.8945 51.4831V50.8734C83.8945 50.736 83.7824 50.6245 83.6444 50.6245H61.5166C61.3786 50.6245 61.2665 50.736 61.2665 50.8734V51.4831H83.8945Z",
    fill: "#DED7C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.1443 89.6471C82.1443 89.7759 82.0496 89.8792 81.933 89.8792H63.2286C63.1114 89.8792 63.0167 89.7759 63.0167 89.6471V53.7322C63.0167 53.6034 63.1114 53.4995 63.2286 53.4995H81.933C82.0496 53.4995 82.1443 53.6034 82.1443 53.7322V89.6471Z",
    fill: "#713229"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.1443 54.6255V53.7322C82.1443 53.6034 82.0496 53.4995 81.933 53.4995H63.2286C63.1114 53.4995 63.0167 53.6034 63.0167 53.7322V54.6255H82.1443Z",
    fill: "#572520"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.8293 75.6144H79.3311V56.2495H65.8293V75.6144Z",
    fill: "#5397B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1417 68.1987L77.9557 57.3848H79.1648L66.1417 68.1987Z",
    fill: "#7EA7BD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.8293 67.0097V56.2495H78.7294L65.8293 67.0097Z",
    fill: "#7EA7BD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.8293 57.0706H79.3311V56.2495H65.8293V57.0706Z",
    fill: "#3A6F86"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.6973 45.2677C93.6973 45.4062 93.5778 45.5177 93.43 45.5177H4.42366C4.27641 45.5177 4.15631 45.4062 4.15631 45.2677V41.2534C4.15631 41.1149 4.27641 41.0034 4.42366 41.0034H93.43C93.5778 41.0034 93.6973 41.1149 93.6973 41.2534V45.2677Z",
    fill: "#D1B59E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.6973 43.7773H4.15631V41.2534C4.15631 41.1149 4.27641 41.0034 4.42366 41.0034H93.43C93.5778 41.0034 93.6973 41.1149 93.6973 41.2534V43.7773Z",
    fill: "#A8856D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.4145 42.3538C94.4145 42.4941 94.2926 42.6084 94.1431 42.6084H3.71112C3.56041 42.6084 3.43858 42.4941 3.43858 42.3538L0.732788 37.3054C0.732788 37.1645 0.861552 37.0508 1.02092 37.0508H96.8327C96.9915 37.0508 97.1214 37.1645 97.1214 37.3054L94.4145 42.3538Z",
    fill: "#EAD0BA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6445 38.1946L97.1214 37.3054C97.1214 37.1645 96.9915 37.0508 96.8327 37.0508H1.02092C0.861552 37.0508 0.732788 37.1645 0.732788 37.3054L1.20916 38.1946H96.6445Z",
    fill: "#DED7C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.6689 87.7541H79.3693V77.1948H65.6689V87.7541Z",
    fill: "#90493F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2468 87.863H78.7912V78.0186H66.2468V87.863Z",
    fill: "#713229"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.6628 75.6155H65.3287V69.5312H63.6628V75.6155Z",
    fill: "#D9893F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.3287 72.2453C65.1312 72.0028 64.8333 71.8457 64.4961 71.8457C64.1588 71.8457 63.8609 72.0028 63.6628 72.2453V73.6109C63.8609 73.8534 64.1588 74.0104 64.4961 74.0104C64.8333 74.0104 65.1312 73.8534 65.3287 73.6109V72.2453Z",
    fill: "#AC6838"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5781 72.3659C65.5781 72.9635 65.0937 73.4485 64.4961 73.4485C63.8984 73.4485 63.4134 72.9635 63.4134 72.3659C63.4134 71.7677 63.8984 71.2832 64.4961 71.2832C65.0937 71.2832 65.5781 71.7677 65.5781 72.3659Z",
    fill: "#F0A96A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.008 95.2131C101.008 95.3511 100.897 95.4625 100.759 95.4625H-5.50449C-5.64249 95.4625 -5.75394 95.3511 -5.75394 95.2131V92.7538C-5.75394 92.6158 -5.64249 92.5044 -5.50449 92.5044H100.759C100.897 92.5044 101.008 92.6158 101.008 92.7538V95.2131Z",
    fill: "#D5BA9F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-5.75394 94.7129V95.2135C-5.75394 95.3515 -5.64249 95.463 -5.50449 95.463H100.759C100.897 95.463 101.008 95.3515 101.008 95.2135V94.7129H-5.75394Z",
    fill: "#B49479"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.008 93.2129V92.7538C101.008 92.6158 100.897 92.5044 100.759 92.5044H-5.50449C-5.64249 92.5044 -5.75394 92.6158 -5.75394 92.7538V93.2129H101.008Z",
    fill: "#DED7C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4382 80.6007H55.1898V50.6245H12.4382V80.6007Z",
    fill: "#EAD0BA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1232 78.0185H52.5048V53.4995H15.1232V78.0185Z",
    fill: "#5397B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3754 67.7947C50.0444 67.7947 48.9641 66.5844 48.9641 65.0912C48.9641 66.5844 47.8849 67.7947 46.5522 67.7947C45.2212 67.7947 44.1409 66.5844 44.1409 65.0912C44.1409 66.5844 43.0611 67.7947 41.729 67.7947C40.3969 67.7947 39.3171 66.5844 39.3171 65.0912C39.3171 66.5844 38.2379 67.7947 36.907 67.7947C35.5737 67.7947 34.4951 66.5844 34.4951 65.0912C34.4951 66.5844 33.4153 67.7947 32.0826 67.7947C30.7511 67.7947 29.6713 66.5844 29.6713 65.0912C29.6713 66.5844 28.5915 67.7947 27.2606 67.7947C25.9291 67.7947 24.8487 66.5844 24.8487 65.0912C24.8487 66.5844 23.7695 67.7947 22.4368 67.7947C21.1047 67.7947 20.0249 66.5844 20.0249 65.0912C20.0249 66.5844 18.9452 67.7947 17.6136 67.7947C16.2815 67.7947 15.2023 66.5844 15.2023 65.0912C15.2023 65.3251 15.1729 65.5508 15.1232 65.7674V53.4995H52.5048V67.4794C52.1676 67.6804 51.7836 67.7947 51.3754 67.7947Z",
    fill: "#48829C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4382 51.9832H55.1898V50.6245H12.4382V51.9832Z",
    fill: "#DED7C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.14467 60.2934C4.4762 60.2934 5.55597 59.0826 5.55597 57.5894H0.732788C0.732788 59.0826 1.81199 60.2934 3.14467 60.2934Z",
    fill: "#802B2A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.96727 60.2934C9.29938 60.2934 10.3797 59.0826 10.3797 57.5894H5.55597C5.55597 59.0826 6.63517 60.2934 7.96727 60.2934Z",
    fill: "#DCC393"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7905 60.2934C14.122 60.2934 15.2024 59.0826 15.2024 57.5894H10.3798C10.3798 59.0826 11.4578 60.2934 12.7905 60.2934Z",
    fill: "#802B2A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6136 60.2934C18.9451 60.2934 20.0249 59.0826 20.0249 57.5894H15.2023C15.2023 59.0826 16.2815 60.2934 17.6136 60.2934Z",
    fill: "#DCC393"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4368 60.2934C23.7695 60.2934 24.8487 59.0826 24.8487 57.5894H20.0249C20.0249 59.0826 21.1047 60.2934 22.4368 60.2934Z",
    fill: "#802B2A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2606 60.2934C28.5915 60.2934 29.6713 59.0826 29.6713 57.5894H24.8487C24.8487 59.0826 25.929 60.2934 27.2606 60.2934Z",
    fill: "#DCC393"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0826 60.2934C33.4153 60.2934 34.495 59.0826 34.495 57.5894H29.6713C29.6713 59.0826 30.751 60.2934 32.0826 60.2934Z",
    fill: "#802B2A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9069 60.2934C38.2378 60.2934 39.317 59.0826 39.317 57.5894H34.495C34.495 59.0826 35.5736 60.2934 36.9069 60.2934Z",
    fill: "#DCC393"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.729 60.2934C43.0611 60.2934 44.1409 59.0826 44.1409 57.5894H39.3171C39.3171 59.0826 40.3969 60.2934 41.729 60.2934Z",
    fill: "#802B2A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5522 60.2934C47.8849 60.2934 48.9635 59.0826 48.9635 57.5894H44.1409C44.1409 59.0826 45.2212 60.2934 46.5522 60.2934Z",
    fill: "#DCC393"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3753 60.2934C52.7074 60.2934 53.7871 59.0826 53.7871 57.5894H48.9634C48.9634 59.0826 50.0443 60.2934 51.3753 60.2934Z",
    fill: "#802B2A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1997 60.2934C57.5306 60.2934 58.6098 59.0826 58.6098 57.5894H53.7872C53.7872 59.0826 54.867 60.2934 56.1997 60.2934Z",
    fill: "#DCC393"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.0216 60.2934C62.3538 60.2934 63.4335 59.0826 63.4335 57.5894H58.6098C58.6098 59.0826 59.6901 60.2934 61.0216 60.2934Z",
    fill: "#802B2A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.84198 42.6738L0.732788 57.5903H5.55597L11.5721 42.6738H7.84198Z",
    fill: "#AF3234"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5721 42.6738L5.55597 57.5903H10.3797L15.3011 42.6738H11.5721Z",
    fill: "#FAE9C6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3011 42.6738L10.3798 57.5903H15.2024L19.0301 42.6738H15.3011Z",
    fill: "#AF3234"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.03 42.6738L15.2023 57.5903H20.0249L22.7601 42.6738H19.03Z",
    fill: "#FAE9C6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7602 42.6738L20.0249 57.5903H24.8487L26.4897 42.6738H22.7602Z",
    fill: "#AF3234"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4897 42.6738L24.8487 57.5903H29.6713L30.2187 42.6738H26.4897Z",
    fill: "#FAE9C6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2187 42.6738L29.6713 57.5903H34.495L33.9476 42.6738H30.2187Z",
    fill: "#AF3234"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9477 42.6738L34.4951 57.5903H39.3171L37.6772 42.6738H33.9477Z",
    fill: "#FAE9C6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6772 42.6738L39.3171 57.5903H44.1409L41.4074 42.6738H37.6772Z",
    fill: "#AF3234"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4074 42.6738L44.1409 57.5903H48.9635L45.1358 42.6738H41.4074Z",
    fill: "#FAE9C6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.1358 42.6738L48.9635 57.5903H53.7873L48.866 42.6738H45.1358Z",
    fill: "#AF3234"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8659 42.6738L53.7873 57.5903H58.6099L52.5943 42.6738H48.8659Z",
    fill: "#FAE9C6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5943 42.6738L58.6098 57.5903H63.4336L56.3238 42.6738H52.5943Z",
    fill: "#AF3234"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1232 78.0182H52.5048V75.2656H15.1232V78.0182Z",
    fill: "#48829C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.008 74.3565C101.008 74.4951 100.897 74.6066 100.759 74.6066H94.6321C94.4947 74.6066 94.3827 74.4951 94.3827 74.3565V51.2251C94.3827 51.0877 94.4947 50.9751 94.6321 50.9751H100.759C100.897 50.9751 101.008 51.0877 101.008 51.2251V74.3565Z",
    fill: "#DED7C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.258 73.3691C100.258 73.4956 100.171 73.5983 100.065 73.5983H95.3256C95.2193 73.5983 95.1327 73.4956 95.1327 73.3691V52.213C95.1327 52.0872 95.2193 51.9844 95.3256 51.9844H100.065C100.171 51.9844 100.258 52.0872 100.258 52.213V73.3691Z",
    fill: "#BC4F39"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.4373 55.7656H94.3827V54.9844H91.4373V55.7656Z",
    fill: "#713229"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.4373 70.5968H94.3827V69.8149H91.4373V70.5968Z",
    fill: "#713229"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5408 36.8533C86.5408 36.9913 86.4288 37.1039 86.2908 37.1039H38.2674C38.1294 37.1039 38.0173 36.9913 38.0173 36.8533V19.9707C38.0173 19.8327 38.1294 19.7207 38.2674 19.7207H86.2908C86.4288 19.7207 86.5408 19.8327 86.5408 19.9707V36.8533Z",
    fill: "#A89784"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.3461 35.552C85.3461 35.6726 85.2405 35.7696 85.1088 35.7696H39.4494C39.3183 35.7696 39.212 35.6726 39.212 35.552V21.2724C39.212 21.1517 39.3183 21.0547 39.4494 21.0547H85.1088C85.2405 21.0547 85.3461 21.1517 85.3461 21.2724V35.552Z",
    fill: "#F4D8C2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 107.4,
    height: 77.9516,
    fill: "white",
    transform: "translate(-6 18)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomersEmpty);
export default __webpack_public_path__ + "static/media/customers-empty.968df17503a7ccfde0e5174930075232.svg";
export { ForwardRef as ReactComponent };